<template>
  <div>
    <Toolbar class="mb-4">
      <template #right>Neue hinzufügen</template>
      <template #left>
        <Button
          icon="pi pi-times"
          class="p-button-danger"
          @click="$router.push('/admin/cat_producat')"
        />
      </template>
    </Toolbar>
    <div class="form-card row">
      <div class="col-md-12 text-center">
        <img
          :src="body.image"
          v-if="id"
          class="profile-pic height-150 width-150 align-items-center"
          style="width: 100px; height: 100px"
        />
        <!-- @error="$errorHandler" -->
      </div>

      <div class="col-md-6">
        <div class="mb-3">
          <label for="name" class="form-label required">
            Name (EN)
            <span>*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="body.name.en"
            :class="{ 'is-invalid': isInvalid && !body.name.en }"
            required
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="mb-3">
          <label for="name" class="form-label required">
            Name (DE)
            <span>*</span>
          </label>
          <input
            type="text"
            class="form-control"
            id="name"
            v-model="body.name.de"
            :class="{ 'is-invalid': isInvalid && !body.name.de }"
            required
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="slug" class="form-label required">
            slug Or Extrnal link (http)
          </label>
          <input
            class="form-control"
            id="slug"
            v-model="body.slug"
            :class="{ 'is-invalid': isInvalid && !body.slug }"
            required
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="parntId" class="form-label required"> Main </label>

          <select
            class="form-select form-control"
            id="parntId"
            name="parntId"
            v-model.number="body.parntId"
            :class="{ 'is-invalid': isInvalid && !body.parntId }"
            required
          >
            <option v-for="i in catList" :key="i.id" :value="i.id">
              {{ JSON.parse(i.name).de }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="mb-3">
          <label for="inhomepage" class="form-label required">
            Main Section
          </label>

          <SelectButton
            v-model="body.cattype"
            :options="optionsList"
            optionValue="value"
            optionLabel="name"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="Image" class="form-label required">
            Image
          </label>

          <div class="align-items-center">
            <div class="profile-img-edit align-items-center">
              <div class="p-image">
                <div class="position-relative">
                  <i class="ri-pencil-line upload-button"></i>
                  <b-form-file
                    class="h-100 position-absolute"
                    accept="image/*"
                    @change="previewImage"
                  ></b-form-file>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="mb-3 mt-5 text-center">
          <Button
            label="Bearbeiten"
            icon="pi pi-pencil"
            class="ml-2 p-button-info"
            @click="update()"
            v-if="id"
            :disabled="disabledAdd"
          />
          <Button
            v-else
            label="Hinzufügen"
            icon="pi pi-plus"
            class="ml-2 p-button-success"
            @click="save()"
            :disabled="disabledAdd"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      body: {
        name: { en: null, de: null },

        slug: null,
        image: null,
        cattype: 0,
        parntId: null,

        linkOrSection: "section",
      },
      id: null,

      catList: [],
      optionsList: [
        { name: "Main", value: 0 },
        { name: "Sub", value: 1 },
      ],

      isInvalid: false,
      disabledAdd: false,
    };
  },
  methods: {
    previewImage(ev) {
      this.$file2base64(ev, (image) => {
        this.body.image = image;
      });
    },
    save() {
      if (this.body.name.en && this.body.name.de) {
        this.disabledAdd = true;

        if (body.image == null) {
          delete body.image;
        }
        this.$http.post(`categories`, this.body).then(
          () => {
            this.$toast.add({
              severity: "success",
              summary: "Done Successfully",
              detail: "Added Successfully",
              life: 3000,
            });
            this.disabledAdd = false;

            this.$router.push("/admin/cat_producat");
          },
          (err) => {
            this.disabledAdd = false;

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      } else {
        this.isInvalid = true;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please add the required fields",
          life: 3000,
        });
      }
    },
    update() {
      if (this.body.name.en && this.body.name.de) {
        this.disabledAdd = true;
        let body = { ...this.body };

        if (body.image.startsWith("http") || body.image == null) {
          delete body.image;
        }
        this.$http.put(`categories/${this.id}`, body).then(
          () => {
            this.$toast.add({
              severity: "success",
              summary: "Done Successfully",
              detail: "Updated Successfully",
              life: 3000,
            });
            this.disabledAdd = false;

            this.$router.push("/admin/cat_producat");
          },
          (err) => {
            this.disabledAdd = false;
            this.$router.push("/admin/cat_producat");

            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: err.response.data.message,
              life: 3000,
            });
          }
        );
      } else {
        this.isInvalid = true;
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Please add the required fields",
          life: 3000,
        });
      }
    },
  },
  created() {
    this.$http.get(`categories?linkOrSection=section`).then((res) => {
      this.catList = res.data.data;
    });

    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.$http.get(`categories/${this.id}`).then(
        (res) => {
          this.body = res.data.data;

          this.body.image = this.$baseUploadURL + this.body.image;
          this.body.name = JSON.parse(this.body.name);
        },
        (err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.response.data.message,
            life: 3000,
          });
        }
      );
    }
  },
};
</script>
